<template>
  <!-- dve celije u redu sa dugmadima za deljenje; svaka celija se menja kad je radnja uradjena:
       levo: Google omiljeni izvor  ->  (kad je kliknut) dugme "besplatan oglas kao fizicko lice"
       desno: prijava za obavestenja ->  (kad je kupac prijavljen) dugme "besplatna tezga" -->
  <div class="gps">

    <!-- Google "omiljeni izvor": jednim klikom citalac dodaje Pijace.com u Top Stories (i AI preglede) -->
    <div v-if="showSource" class="gps-col">
      <span class="gps-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" /></svg>
      </span>

      <div class="gps-body">
        <p class="gps-title">Pijace.com na Google-u</p>
        <p class="gps-text">Dodajte nas kao omiljeni izvor u Google-u.</p>
      </div>

      <!-- pravi link: bez JavaScript-a (ili pre ucitavanja Google skripte) otvara Google-ova podesavanja izvora -->
      <a class="gps-btn" :href="deeplink" target="_blank" rel="noopener" title="Otvara se Google prozor za potvrdu" @pointerenter="loadScript" @focus="loadScript" @click="onClick">
        <span class="gps-g" aria-hidden="true">
          <img :src="GOOGLE_G" alt="" width="18" height="18" loading="lazy" />
        </span>
        <span>Dodaj kao omiljeni izvor</span>
      </a>
    </div>

    <!-- omiljeni izvor je dodat: oglas kao fizicko lice -->
    <NuxtLink v-else :to="{ name: 'korisnicki-profil-meni' }" class="tezga-inline-banner-link gps-promo">
      <div class="tezga-inline-banner">
        <div class="tezga-inline-content">
          <div class="tezga-inline-icon bg-info">
            <i class="esei icon-user-solid"></i>
          </div>
          <div class="tezga-inline-text">
            <div class="tezga-inline-title">
              <span class="tezga-inline-full">Postavite BESPLATNO OGLAS kao fizičko lice!</span>
              <span class="tezga-inline-short">Besplatan oglas</span>
            </div>
          </div>
        </div>
      </div>
    </NuxtLink>

    <!-- prijava za obavestenja (zvonce, poruke za oglase, pratioci) -->
    <div v-if="showLogin" class="gps-col">
      <span class="gps-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 22a2.5 2.5 0 0 0 2.45-2h-4.9A2.5 2.5 0 0 0 12 22Zm7-6V11a7 7 0 0 0-5.5-6.84V3.5a1.5 1.5 0 0 0-3 0v.66A7 7 0 0 0 5 11v5l-2 2v1h18v-1l-2-2Z" /></svg>
      </span>

      <div class="gps-body">
        <p class="gps-title">Dobijajte obaveštenja</p>
        <p class="gps-text">Poruke za oglase, pratioci i vesti u zvoncu.</p>
      </div>

      <!-- pravi link: login stranica sama pokrece Google prijavu (radi i pre ucitavanja skripti) -->
      <a class="gps-btn gps-btn-light" href="/login?social=google" title="Ili prijava mejlom na stranici za prijavu">
        <span class="gps-g" aria-hidden="true">
          <img :src="GOOGLE_G" alt="" width="18" height="18" loading="lazy" />
        </span>
        <span>Prijavi se preko Google-a</span>
      </a>
    </div>

    <!-- kupac je prijavljen: registracija tezge -->
    <NuxtLink v-else :to="{ name: 'kako-kreirati-tezga-profil' }" class="tezga-inline-banner-link gps-promo">
      <div class="tezga-inline-banner">
        <div class="tezga-inline-content">
          <div class="tezga-inline-icon">
            <i class="esei icon-store-solid"></i>
          </div>
          <div class="tezga-inline-text">
            <div class="tezga-inline-title">
              <span class="tezga-inline-full">Registrujte BESPLATNO TEZGU i objavljujte oglase!</span>
              <span class="tezga-inline-short">Besplatna tezga</span>
            </div>
          </div>
          <div class="tezga-inline-btn">Saznaj više</div>
        </div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import { useCustomerLoginStore } from '~/stores/login/customer'

const GOOGLE_G = '/images/google-g.svg'
const deeplink = 'https://www.google.com/preferences/source?q=pijace.com'
const SCRIPT_SRC = 'https://news.google.com/swg/js/v1/publisher.js'

const login = useCustomerLoginStore()
const loggedIn = computed(() => !!login.loggedIn)

// Google ne javlja da li je omiljeni izvor stvarno dodat, pa se pamti da je kupac kliknuo dugme (kolacic, da ga zna i server)
const sourceCookie = useCookie('pijace_pref_source', { maxAge: 60 * 60 * 24 * 180, sameSite: 'lax', path: '/' })
const sourceDone = ref(Boolean(sourceCookie.value))

const showSource = computed(() => !sourceDone.value)
const showLogin = computed(() => !loggedIn.value)

// Google-ov API (kad se ucita); do tada dugme radi kao obican link
let api = null

const INTERACTION_EVENTS = ['pointermove', 'pointerdown', 'scroll', 'touchstart', 'keydown']

function loadScript() {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return

  const script = document.createElement('script')
  script.async = true
  script.setAttribute('preferred-sources-control', 'manual')
  script.src = SCRIPT_SRC
  document.head.appendChild(script)
}

// "manual": Google ne crta svoje dugme, nego koristimo sopstveno i zovemo addPreferredSource()
onMounted(() => {
  (self.PREFERRED_SOURCE = self.PREFERRED_SOURCE || []).push((preferredSource) => {
    preferredSource.init({ theme: 'light' })
    api = preferredSource
  })

  // Google skripta se ucitava tek pri prvoj radnji posetioca (kretanje misa, skrol, dodir, tastatura) ili kad se
  // pokaze na dugme, da ne opterecuje prvo ucitavanje; do tada dugme radi kao obican link
  INTERACTION_EVENTS.forEach((name) => window.addEventListener(name, loadScript, { once: true, passive: true }))
})

onBeforeUnmount(() => {
  INTERACTION_EVENTS.forEach((name) => window.removeEventListener(name, loadScript))
})

// ako je Google API spreman, tok ide u njegovom prozoru; inace ostaje podrazumevani link
const onClick = (event) => {
  // celija se menja tek posle kratkog vremena, da Googleov prozor stigne da se otvori
  sourceCookie.value = true
  setTimeout(() => { sourceDone.value = true }, 1500)

  if (!api) return

  event.preventDefault()
  api.addPreferredSource()
}
</script>
